import React, {useEffect, useState} from 'react'
import Loading from "components/Loading";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import {connect} from "react-redux";
import OpinionMessage from "./OpinionMessage";
import NewOpinionMessage from "./NewOpinionMessage";
import GridBlock from "components/GridBlock";
import AddIcon from "@material-ui/icons/AddBoxOutlined";
import Tr from "translations/Translations";
import BoldTypography from "components/BoldTypography";
import WorkableButton from "components/button/WorkableButton";

function OpinionElementContent(
    {
        groupId,
        opinion,
        coordinatorView,
        opinionMessages,
        editable,
        apiPathType
    }) {

    const [addWorking, setAddWorking] = useState(false);

    useEffect(() => {
        PurchasingGroupStage1Service.getOpinionMessages(groupId, apiPathType, opinion.identity, editable)
        return () => {
            PurchasingGroupStage1Service.clearResources(PurchasingGroupStage1Service.PURCHASING_GROUP_OPINION_MESSAGES_RESOURCE_ID(opinion.identity))
        }
        // eslint-disable-next-line
    }, [])


    if (!opinionMessages)
        return <Loading/>
    return (<div>

        {(opinionMessages.length === 0) && <BoldTypography align='center' variant="h6">{Tr('no_options')}</BoldTypography>}

        {
            opinionMessages.map(x => x.status === 'SENT' ? <OpinionMessage key={x.identity} message={x} coordinatorView={coordinatorView}/> :
                <NewOpinionMessage key={x.identity} editable={editable} groupId={groupId} message={x} coordinatorView={coordinatorView} opinion={opinion} apiPathType={apiPathType}/>
            )
        }
        {
            opinion.identity > 0 && <GridBlock justify="flex-end">
                <WorkableButton
                    Icon={AddIcon}
                    variant="outlined" working={addWorking} disabled={!editable || addWorking}
                    onClick={() => {
                        setAddWorking(true);
                        PurchasingGroupStage1Service.addEmptyOpinionMessage(groupId, apiPathType, opinion.identity, editable).finally(() => setAddWorking(false))
                    }}>{Tr("new_message")}
                </WorkableButton>
            </GridBlock>
        }


    </div>)
}

OpinionElementContent.propTypes = {}

export default connect((state, {opinion}) => ({
    opinionMessages: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_OPINION_MESSAGES_RESOURCE_ID(opinion.identity)]
}), {})(OpinionElementContent);